import HiristSaveJob from './save-job.svg';
import HiristArrowEnabled from './arrow-enabled.svg';
import HiristArrowDisabled from './arrow-disabled.svg';
import HiristBriefcase from './old-fashion-briefcase-white.svg';
import HiristOpenBook from './open-book-white.svg';
import HiristRupee from './rupee-indian-white.svg';
import HiristClock from './clock-circular-outline-white.svg';
import HiristInfoIcon from './information.svg';
import HiristIconNotification from './icon-notification.svg';
import HiristInformationIcon from './info.svg';

export {
  HiristClock,
  HiristRupee,
  HiristSaveJob,
  HiristOpenBook,
  HiristInfoIcon,
  HiristBriefcase,
  HiristArrowEnabled,
  HiristArrowDisabled,
  HiristIconNotification,
  HiristInformationIcon,
};
